import ViewDeliveryOrder from "../../../../components/@documents/delivery_orders/ViewDeliveryOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function DeliveryOrderViewPage() {

    return (
        <ViewDeliveryOrder 
            routeType={routeTypes.admin}
        />
    )
}